import { render, staticRenderFns } from "./VaBadge.vue?vue&type=template&id=93e28b2a&scoped=true&"
import script from "./VaBadge.vue?vue&type=script&lang=ts&"
export * from "./VaBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e28b2a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93e28b2a')) {
      api.createRecord('93e28b2a', component.options)
    } else {
      api.reload('93e28b2a', component.options)
    }
    module.hot.accept("./VaBadge.vue?vue&type=template&id=93e28b2a&scoped=true&", function () {
      api.rerender('93e28b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/VaBadge.vue"
export default component.exports